import { VIEWER_IS_SELECTING_CENTERLINE_START } from '../actions';

export default function setIsSelectingCenterlineStart(isSelectingCenterlineStart) {
  return {
    type: VIEWER_IS_SELECTING_CENTERLINE_START,
    isSelectingCenterlineStart,
  };
}
